import type { Sport } from '@sorare/core/src/__generated__/globalTypes';

type CategoryVariables = { slug: string; databaseId: string }[];

export const getCategoryVariables = ({
  category,
  sport,
}: {
  category: Nullable<string>;
  sport: Nullable<Sport>;
}) => {
  const sportCategory = sport?.toLowerCase();

  if (!category) {
    return [];
  }

  let footballCategoryVariable;
  switch (category) {
    case 'fantasy-meets-reality':
      footballCategoryVariable = [
        {
          slug: 'fantasy-meets-reality',
          databaseId: '1515',
        },
      ];
      break;
    case 'get-started':
      footballCategoryVariable = [{ slug: 'get-started', databaseId: '1500' }];
      break;
    default:
      footballCategoryVariable = [{ slug: 'news', databaseId: '1505' }];
  }

  const MlbCategoriesVariables =
    category === 'news'
      ? [
          { slug: 'gameplay-updates-mlb', databaseId: '1501' },
          { slug: 'mlb-scouting', databaseId: '1509' },
          { slug: 'nba-special-events', databaseId: '1513' },
        ]
      : [{ slug: 'mlb-community-stories', databaseId: '1507' }];

  const NbaCategoriesVariables =
    category === 'news'
      ? [
          { slug: 'gameplay-updates-nba', databaseId: '1502' },
          { slug: 'scouting', databaseId: '1499' },
          { slug: 'nba-special-events', databaseId: '1513' },
        ]
      : [{ slug: 'nba-community-stories', databaseId: '1512' }];

  let categoriesVariables: CategoryVariables;
  switch (sportCategory) {
    case 'nba':
      categoriesVariables = NbaCategoriesVariables;
      break;
    case 'mlb':
      categoriesVariables = MlbCategoriesVariables;
      break;
    default:
      categoriesVariables = footballCategoryVariable;
  }

  return categoriesVariables;
};
